import React from 'react';
import BaseStage from '../BaseStage/BaseStage';
import HeaderWithLogo from '../HeaderWithLogo/HeaderWithLogo';
import styles from './NarrowStageWithLogo.module.scss';

const NarrowStageWithLogo = ({ title, subtitle, logo, type, pageName }) => {
  const headersProps = { title, subtitle, logo, type };

  return (
    <BaseStage
      pageName={ pageName }
      additionalClass={ styles.NarrowStageWithLogo }
    >
      <HeaderWithLogo
        { ...headersProps }
      />
    </BaseStage>
  );
};
 
export default NarrowStageWithLogo;
